import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import Header from "../partials/Header";
import Footer from "../partials/Footer";

const YOUFORM_EMBED_SCRIPT = "https://app.youform.com/embed.js";
const YOUFORM_FORM_ID = "bk36arac";

const Register = () => {
  useEffect(() => {
    const initializeEmbed = () => {
      if (window.YouformEmbed) {
        window.YouformEmbed.init();
      }
    };

    let script = document.querySelector(
      `script[src="${YOUFORM_EMBED_SCRIPT}"]`
    );

    if (script) {
      initializeEmbed();
    } else {
      script = document.createElement("script");
      script.src = YOUFORM_EMBED_SCRIPT;
      script.async = true;
      document.body.appendChild(script);
    }

    script.addEventListener("load", initializeEmbed);

    return () => {
      script.removeEventListener("load", initializeEmbed);
    };
  }, []);

  return (
    <div className="flex flex-col min-h-screen overflow-hidden">
      <Header />
      <main className="flex-grow">
        <section className="relative">
          <div className="pt-32 pb-12 md:pt-40 md:pb-20 mx-4">
            <div className="max-w-6xl mx-auto">
              <h1
                className="text-3xl md:text-4xl font-extrabold leading-tighter tracking-tighter mb-4"
                data-aos="zoom-y-out"
              >
                <span className="bg-clip-text text-transparent bg-gradient-to-r from-blue-500 to-teal-400">
                  Dragon Rush 8 Registration
                </span>
              </h1>
              <div className="flex gap-4 mb-8" data-aos="zoom-y-out">
                <a
                  href="https://discord.gg/D97aSeBgDB"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="px-6 py-2 bg-indigo-600 hover:bg-indigo-700 text-white font-semibold rounded shadow transition"
                >
                  Join our Discord
                </a>
                <Link
                  to="/rules"
                  className="px-6 py-2 bg-gray-200 hover:bg-gray-300 text-gray-800 font-semibold rounded shadow transition"
                >
                  Event Rules
                </Link>
              </div>
              <div
                data-youform-embed
                data-form={YOUFORM_FORM_ID}
                data-width="100%"
                data-height="900"
                data-autoresize
              ></div>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
};

export default Register;
